module.exports = __webpack_public_path__ + "static/media/Ancient-Aliens.f33663d7.jpg";